import Stash from 'src/stash';

export default {
  data() {
    return {
      state: Stash.state,
    };
  },
};



// WEBPACK FOOTER //
// ./src/mixins/InteractsWithState.js